module.exports = __webpack_public_path__ + "static/media/5-_DSC0814.7a82e54d.jpg";